import FileUploadModal from './FileUploadModal';

export { FileUploadTypes } from './FileUploadModalProps';
export default FileUploadModal;
